import React from 'react';
import { Box, Typography, Grid, Card, CardMedia, Accordion, AccordionSummary, AccordionDetails, Divider } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { IAnomalias, IImagemAnomalia } from '../../../services/api/anomaly/AnomalyService';
import AccordionHistoryAnomaly from './AccordionHistoryAnomaly';
import { formatDateWhitoutHour } from '../../../services/helpers/helpers';

interface HistoricoAnomaliaProps {
    data: IAnomalias;
}

const HistoricoAnomalia: React.FC<HistoricoAnomaliaProps> = ({ data }) => {	

    // const getImageUrl = (imageData: string | null | undefined): string | undefined => {
    //     if (!imageData) {
    //         return undefined;
    //     }
    //     if (imageData.startsWith('data:image/')) {
    //         return imageData;
    //     }
    //     return `data:image/jpeg;base64,${imageData}`;
    // };

    const parseDateForSort = (dateStr: string | null | undefined): number => {
        if (!dateStr) return 0;
        // dd/MM/yyyy → yyyy-MM-dd
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
            const [d, m, y] = dateStr.split('/');
            return new Date(`${y}-${m}-${d}`).getTime();
        }
        // "yyyy-MM-dd HH:mm" → ISO
        const normalized = /^\d{4}-\d{2}-\d{2} /.test(dateStr) ? dateStr.replace(' ', 'T') : dateStr;
        const ts = new Date(normalized).getTime();
        return isNaN(ts) ? 0 : ts;
    };

    const detalhesHistorico = [...(data.detalhes[0]?.historico || [])].sort(
        (a, b) => parseDateForSort(b.data_inspecao) - parseDateForSort(a.data_inspecao)
    );
    const imagensAnomalia = [...(data.imagens || [])].sort(
        (a, b) => parseDateForSort(b.date) - parseDateForSort(a.date)
    );

    return (
        <Box sx={{ mt: 2 }}>
            <Typography variant="h5" sx={{ mb: 2 }}>
                Histórico de Detalhes de Inspeção
            </Typography>
            {detalhesHistorico.length === 0 ? (
                <Typography variant="body1" sx={{ p: 2, textAlign: 'center' }}>Nenhum registro de detalhes históricos foi criado.</Typography>
            ) : (
                <AccordionHistoryAnomaly data={detalhesHistorico} />
            )}

            <Divider sx={{ my: 4 }} />

            <Typography variant="h5" sx={{ mb: 2 }}>
                Imagens Registradas
            </Typography>
            {imagensAnomalia.length === 0 ? (
                <Typography variant="body1" sx={{ p: 2, textAlign: 'center' }}>Nenhuma imagem registrada para esta anomalia.</Typography>
            ) : (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, paddingY: 2, width: '100%' }}>
                    {imagensAnomalia.map((imagem: IImagemAnomalia, index: number) => (
                        <Accordion
                            key={imagem.data ? imagem.data.substring(0, 50) + index : `imagem-${index}`}
                            square={true}
                            sx={{ borderRadius: '8px', '&:before': { display: 'none' } }}
                            disableGutters
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMore />}
                                sx={{
                                    borderRadius: '8px',
                                }}
                            >
                                <Typography variant='subtitle1'>
                                    <strong>Imagem {index + 1}</strong>
                                    {imagem.date && ` - ${formatDateWhitoutHour(imagem.date)}`}
                                    {imagem.legenda && ` - "${imagem.legenda}"`}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        {imagem.data && (
                                            <Card>
                                                <CardMedia
                                                    component="img"
                                                    height="300"
                                                    image={imagem.data}
                                                    alt={`Imagem ${index + 1}`}
                                                    sx={{ objectFit: 'contain', bgcolor: '#f0f0f0' }}
                                                />
                                            </Card>
                                        )}
                                    </Grid>
                                    <Grid item xs={12}>
                                        {imagem.date && (
                                            <Typography variant="body2">
                                                <strong>Data:</strong> {formatDateWhitoutHour(imagem.date)}
                                            </Typography>
                                        )}
                                        {imagem.legenda && (
                                            <Typography variant="body2">
                                                <strong>Legenda:</strong> {imagem.legenda}
                                            </Typography>
                                        )}
                                        {imagem.observacoes && imagem.observacoes !== imagem.legenda && (
                                            <Typography variant="body2">
                                                <strong>Observações:</strong> {imagem.observacoes}
                                            </Typography>
                                        )}
                                        {!imagem.legenda && !imagem.observacoes && (
                                            <Typography variant="body2" color="text.secondary">
                                                Sem legenda ou observações.
                                            </Typography>
                                        )}
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </Box>
            )}
        </Box>
    );
};

export default HistoricoAnomalia;